module.exports = __webpack_public_path__ + "img/favorite.af8ad938.svg";